<form [formGroup]="form"
  (submit)="onSubmit()">
  <h2>Serious Concern Alert</h2>
  <p>
    <mat-slide-toggle formControlName="severeConcernWarning">
      Display serious concern alert in app
    </mat-slide-toggle>

  </p>

  <p>
    <mat-form-field class="large">
      <textarea matInput
        rows="6"
        formControlName="severeConcernMessage"
        placeholder="Message for Staff"></textarea>
    </mat-form-field>
  </p>

  <h2>Message Sharing</h2>
  <p>
    Automatically share with family:
  </p>
  <p>
    <mat-slide-toggle formControlName="autoShareLow">
      Postcard
    </mat-slide-toggle>
  </p>
  <p>
    <mat-slide-toggle formControlName="autoShareMid">
      Note
    </mat-slide-toggle>
  </p>
  <p>
    <mat-slide-toggle formControlName="autoShareHigh">
      Flag
    </mat-slide-toggle>
  </p>
  <p>
    <mat-slide-toggle formControlName="autoShareSevere">
      Alert
    </mat-slide-toggle>
  </p>

  <h2>Check In Sharing</h2>
  <p>Display check-ins to family</p>
  <mat-slide-toggle [formControl]="shareCheckIns"></mat-slide-toggle>
  <ng-container *ngIf="shareCheckIns.value">
    <p>which fall between:</p>
    <div class="check-in-selector">
      <img [src]="form.get('maxCheckInShareScore').value | scoreIcon">
      <mat-slider color="primary"
        formControlName="maxCheckInShareScore"
        min="0"
        max="3"
        step="1"></mat-slider>
    </div>
    <p style="text-align: center;">
      and
    </p>
    <div class="check-in-selector">
      <img [src]="form.get('minCheckInShareScore').value | scoreIcon">
      <mat-slider color="primary"
        formControlName="minCheckInShareScore"
        min="0"
        max="3"
        step="1"></mat-slider>
    </div>
  </ng-container>
  <p>
    <button mat-flat-button
      color="primary">Save Preferences</button>
  </p>
</form>